export default __webpack_public_path__ + "static/server-74eddaaeac17cc5808befd197c77c7ce.png";